import { app } from "../firebase/firebase";
import { getFirestore, collection, addDoc } from "firebase/firestore";

export default function Newsletter() {

    const db = getFirestore(app);

    async function subscribe(formData) {
        const docRef = await addDoc(collection(db, "subscribers"), {
            email: formData.get("emailNewsletter")
        }).then(() => {
            alert("Deine E-Mail-Adresse \n" + formData.get("emailNewsletter") + "\nwurde erfolgreich hinzugefügt.")
        }).catch(e => {
            console.log(e.message)
        });
        return docRef
    }
    return (
        <div className='mt-3 mb-5'> 
            <form action={subscribe}>
                <input type="email" className="form-control" name="emailNewsletter" placeholder="name@domain.de" required/>
                <div className='mt-3'>
                    <button type="submit" className="btn btn-primary">Newsletter abonnieren</button>
                </div>
            </form>
        </div>
    );
}